import { render, staticRenderFns } from "./OrganisationWindowView.vue?vue&type=template&id=0195865c&scoped=true&"
import script from "./OrganisationWindowView.vue?vue&type=script&lang=js&"
export * from "./OrganisationWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0195865c",
  null
  
)

export default component.exports